import React from 'react';
import { Button, Form, Header, Segment, Input } from 'semantic-ui-react';
import axios from 'axios';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;


export default class VehicleFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationalUnitId: null,
            manufacturer: null,
            type: null,
            status: null,
            model: null,
            licencePlate: null,
            chassisNumber: null,
            numberOfSeats: null,
            purchaseYear: null,
            productionYear: null,
            fuelType: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
    }

    onFilterData() {
        const vehFilter = {
            organizationalUnit: this.state.organizationalUnitId,
            manufacturer: this.state.manufacturer,
            type: this.state.type,
            status: this.state.status,
            model: this.state.model,
            licencePlate: this.state.licencePlate,
            chassisNumber: this.state.chassisNumber,
            numberOfSeats: this.state.numberOfSeats,
            purchaseYear: this.state.purchaseYear,
            productionYear: this.state.productionYear,
            fuelType: this.state.fuelType
        };

        this.props.onFilterData(vehFilter);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        return (
            <Segment raised>
                <Form>
                    <Header as="h3">O vozilu</Header>
                    {this.props.organizationalUnitsPrivilege &&
                    <Form.Group widths="4">
                        <Form.Dropdown clearable
                            label="Organizaciona jedinica"
                            placeholder="Organizaciona jedinica"
                            value={this.state.organizationalUnitId}
                            onChange={this.handleInputChange}
                            name="organizationalUnitId"
                            options={this.props.organizationalUnits}
                            search
                            fluid
                            selection
                        />
                    </Form.Group>
                    }
                    <Form.Group widths="4">
                        <Form.Dropdown clearable
                            label="Proizvođač"
                            placeholder="Proizvođač"
                            value={this.state.manufacturer}
                            onChange={this.handleInputChange}
                            name="manufacturer"
                            options={this.props.lookups.manufacturers}
                            search
                            fluid
                            selection
                        />
                        <Form.Field
                            label="Model"
                            control={Input}
                            name="model"
                            value={this.state.model}
                            onChange={this.handleInputChange}
                            placeholder="Model"
                        />
                        <Form.Dropdown clearable
                            label="Tip"
                            placeholder="Tip"
                            value={this.state.type}
                            onChange={this.handleInputChange}
                            name="type"
                            options={this.props.lookups.types}
                            search
                            fluid
                            selection
                        />
                    </Form.Group>
                    <Header as="h3">Specifikacije vozila</Header>
                    <Form.Group widths="4">
                        <Form.Field
                            type="text"
                            label="Tablice"
                            control={Input}
                            name="licencePlate"
                            value={this.state.licencePlate}
                            onChange={this.handleInputChange}
                            placeholder="Tablice"
                        />
                        <Form.Field
                            type="text"
                            label="Šasija"
                            control={Input}
                            name="chassisNumber"
                            value={this.state.chassisNumber}
                            onChange={this.handleInputChange}
                            placeholder="Broj šasije"
                        />
                        <Form.Field
                            type="number"
                            label="Broj sjedišta"
                            control={Input}
                            name="numberOfSeats"
                            value={this.state.numberOfSeats}
                            onChange={this.handleInputChange}
                            placeholder="Broj sjedišta"
                        />
                    </Form.Group>
                    <Form.Group widths="4">
                        <Form.Field
                            type="number"
                            label="Godina proizvodnje"
                            control={Input}
                            name="productionYear"
                            value={this.state.productionYear}
                            onChange={this.handleInputChange}
                            placeholder="Godina proizvodnje"
                        />
                        <Form.Field
                            type="number"
                            label="Godina nabavke"
                            control={Input}
                            name="purchaseYear"
                            value={this.state.purchaseYear}
                            onChange={this.handleInputChange}
                            placeholder="Godina nabavke"
                        />
                        <Form.Dropdown clearable
                            label="Status"
                            placeholder="Status"
                            value={this.state.status}
                            onChange={this.handleInputChange}
                            name="status"
                            options={this.props.lookups.statuses}
                            search
                            fluid
                            selection
                        />
                        <Form.Dropdown clearable
                            label="Tip goriva"
                            placeholder="Tip goriva"
                            value={this.state.fuelType}
                            onChange={this.handleInputChange}
                            name="fuelType"
                            options={this.props.lookups.fuelTypes}
                            search
                            fluid
                            selection
                        />
                    </Form.Group>
                    <Button
                        color="blue"
                        onClick={() => this.onFilterData()}
                    >
                        Filtriraj
                    </Button>
                    <Button
                        basic
                        color="blue"
                        onClick={this.props.cancelFilter}
                    >
                        Odustani
                    </Button>
                </Form>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Vehicles/VehicleFilter.js